module.exports = __webpack_public_path__ + "assets/img/video3.df19b0e1.png";